module.exports = __webpack_public_path__ + "static/media/Promos_40_.10d084f7.png";